import {
  createRef,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import {
  IDistributorMaster,
  DistributorMasterListProps,
} from "./IDistributorMaster";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DistributorMasterForm from "./DistributorMasterForm";
import CompletePopup from "../components/response-pop-up";
import { clearCreateDistributorMaster } from "../../redux/distributor-master/createDistributorMaster";
import { clearEditDistributorMaster } from "../../redux/distributor-master/editDistributorMaster";

const DistributorMasterList: FunctionComponent<DistributorMasterListProps> = ({
  open,
  setOpen,
  status,
  ...props
}) => {
  const [isEdit, setEdit] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<IDistributorMaster>({
    active: true,
  });
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);

  const fileRep = createRef<any>();
  const dispatch = useAppDispatch();

  const stateOpetionList: any = useAppSelector((state) => state.GeneralSetting);

  const { isLoading: createDistributorLoading, data: createDistributor } =
    useAppSelector((state) => state.CreateDistributorMaster);

  const { isLoading: editDistributorLoading, data: editDistributor } =
    useAppSelector((state) => state.EditDistributorMaster);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };
  const { distributor } = props;

  useEffect(() => {
    if (
      Object.keys(editDistributor ?? {}).length ||
      Object.keys(createDistributor ?? {}).length
    ) {
      handleClose();
    }
  }, [editDistributor, createDistributor]);
  return (
    <Fragment>
      {!status && (
        <Fragment>
          <div className="content_header justify-content-end">
            <div className="btns">
              <Button
                className="common_btn_outline"
                disableRipple
                onClick={() => {
                  handleClickOpen();
                  setInitialValues(distributor ?? {});
                }}
              >
                Edit
                <FontAwesomeIcon icon="edit" title="Edit partner onboarding" />
              </Button>
            </div>
          </div>

          <div className="scroll_content_container scroll_content_container_2">
            <div className="grid_container">
              <div className="detail_item">
                <label className="f4">Distributor Name</label>
                <p>{distributor?.name}</p>
              </div>
              <div className="detail_item">
                <label className="f4">Distributor Type</label>
                <p>{distributor?.type ?? "--"}</p>
              </div>
              <div className="detail_item">
                <label className="f4">Code</label>
                <p>{distributor?.code}</p>
              </div>
              <div className="detail_item">
                <label className="f4">City</label>
                <p>{distributor?.city}</p>
              </div>
              <div className="detail_item">
                <label className="f4">State</label>
                <p>
                  {stateOpetionList?.data?.result?.find((e: any) => {
                    return e.name === distributor?.state;
                  })?.description ?? null}
                </p>
              </div>
              <div className="detail_item">
                <label className="f4 text_ellipsis">Email</label>
                <p>{distributor?.email}</p>
              </div>

              <div className="detail_item">
                <label className="f4">Status</label>
                <p>{distributor?.active ? "Active" : "InActive"}</p>
              </div>
            </div>
          </div>
          {/* <MainTable mainTableData={filterarr} nonObject={true} /> */}
        </Fragment>
      )}

      <Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth={"md"}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="dialog_header common_border_bottom">
            <h4 id="alert-dialog-title" className="f4">
              {"Add Distributor"}
            </h4>

            <CancelIcon
              onClick={() => {
                handleClose();
              }}
            />
          </div>
          <DistributorMasterForm
            initialValues={initialValues}
            handleClose={handleClose}
            setInitialValues={setInitialValues}
          />
        </Dialog>

        <CompletePopup
          data={{ data: createDistributor }}
          responsePopup={Object.keys(createDistributor ?? {}).length}
          setCompletePopup={(e: any) => {
            dispatch(clearCreateDistributorMaster());
            setResponsePopup(false);
          }}
        />
        <CompletePopup
          data={{ data: editDistributor }}
          responsePopup={Object.keys(editDistributor ?? {}).length}
          setCompletePopup={(e: any) => {
            dispatch(clearEditDistributorMaster());
            setResponseEdit(false);
          }}
        />
      </Fragment>
    </Fragment>
  );
};

export default DistributorMasterList;
